require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-bics-elana-berger-testifies-before-house-financial-services-subcommittee.json") })
        }
      }, "path---en-us-update-bics-elana-berger-testifies-before-house-financial-services-subcommittee");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-bics-elana-berger-testifies-before-house-financial-services-subcommittee!./.cache/json/en-us-update-bics-elana-berger-testifies-before-house-financial-services-subcommittee.json
// module id = 631
// module chunks = 231608221292675